module.exports = __webpack_public_path__ + "static/img/galaxy-backbone-logo.d89307c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/galaxy-backbone-logo.png
// module id = MhLv
// module chunks = 1